(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wistgo-order-confirmation"] && !Shopify.designMode) return;
  try {
    (() => {
    const template = document.getElementById('wistgo-confirmation-template');
    if (!template) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const celebrate = card => {
      card.querySelector('.wg-confetti')?.remove();
      if (reduceMotion.matches) return;
      const layer = document.createElement('div');
      layer.className = 'wg-confetti';
      layer.setAttribute('aria-hidden', 'true');
      const colours = ['#c9a24d', '#123e2f', '#d8c487', '#8da895'];
      for (let index = 0; index < 36; index++) {
        const piece = document.createElement('i');
        piece.style.setProperty('--left', (Math.random() * 100) + '%');
        piece.style.setProperty('--delay', (Math.random() * 350) + 'ms');
        piece.style.setProperty('--drift', (Math.random() * 160 - 80) + 'px');
        piece.style.setProperty('--turn', (Math.random() * 720 - 360) + 'deg');
        piece.style.setProperty('--colour', colours[index % colours.length]);
        layer.append(piece);
      }
      card.append(layer);
      setTimeout(() => layer.remove(), 3200);
    };
    const enhance = modal => {
      if (modal.dataset.wistgoEnhanced) return;
      const content = modal.querySelector('#es-modal-content');
      if (!content) return;
      modal.dataset.wistgoEnhanced = 'true';
      const previousFocus = document.activeElement;
      const previousOverflow = document.body.style.overflow;
      content.replaceChildren(template.content.cloneNode(true));
      modal.classList.add('wg-confirm');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'wg-confirm-title');
      document.body.style.overflow = 'hidden';
      const card = content.querySelector('.wg-confirm-card');
      const close = () => {
        document.body.style.overflow = previousOverflow;
        if (modal.dataset.wistgoPreview === 'true') {
          modal.remove();
          const url = new URL(location.href);
          url.searchParams.delete('wistgo_confirmation_preview');
          history.replaceState(null, '', url);
          previousFocus?.focus?.({ preventScroll: true });
        } else {
          const nativeClose = modal.querySelector('.es-modal-header');
          if (nativeClose) nativeClose.click();
          else { modal.remove(); window.location.reload(); }
        }
      };
      card.querySelector('[data-wg-close]').addEventListener('click', close);
      modal.addEventListener('click', event => { if (event.target === modal) close(); });
      modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key !== 'Tab') return;
        const focusable = [...card.querySelectorAll('a[href],button')];
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      if (modal.dataset.wistgoPreview === 'true') {
        const note = document.createElement('p');
        note.className = 'wg-confirm-preview-note';
        note.append(document.createTextNode('Aperçu — aucune commande créée · '));
        const replay = document.createElement('button');
        replay.type = 'button';
        replay.className = 'wg-confirm-replay';
        replay.textContent = 'Rejouer';
        replay.addEventListener('click', () => celebrate(card));
        note.append(replay);
        card.append(note);
      }
      requestAnimationFrame(() => {
        celebrate(card);
        card.querySelector('[data-wg-close]').focus({ preventScroll: true });
      });
    };
    const scan = () => {
      const modal = document.getElementById('es-thanks-modal');
      if (modal) enhance(modal);
    };
    const observer = new MutationObserver(scan);
    observer.observe(document.body, { childList: true, subtree: true });
    scan();
    if (template.dataset.previewAllowed === 'true' && new URLSearchParams(location.search).get('wistgo_confirmation_preview') === '1') {
      const preview = document.createElement('div');
      preview.id = 'es-thanks-modal';
      preview.className = 'es-modal';
      preview.dataset.wistgoPreview = 'true';
      const container = document.createElement('div');
      container.className = 'es-thanks-container';
      const content = document.createElement('div');
      content.id = 'es-modal-content';
      container.append(content);
      preview.append(container);
      document.body.append(preview);
      enhance(preview);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
